<template>
  <div class="layout-softphone">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'LayoutSoftphone'
}
</script>

<style lang="scss" scoped>
/**
 * The widget owns a small window of its own, so it gets no sidebar, no header and no account
 * summary - every one of those would either not fit or invite the agent to navigate away from the
 * only window allowed to hold the call.
 */
.layout-softphone {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 1rem;
}
</style>
